import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { cn } from "@/app/_utils/cn";
import ShowMonthNavSkeleton from "./ShowMonthNavSkeleton";

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function ShowCalendarSkeleton() {
  return (
    <div className="flex min-h-[calc(100vh-180px)] flex-1 flex-col overflow-hidden rounded-md border border-border bg-card">
      <ShowMonthNavSkeleton />
      <div className="grid shrink-0 grid-cols-7 border-b border-border bg-muted/50">
        {DAY_NAMES.map((d) => (
          <div key={d} className="px-2 py-1.5">
            <Skeleton className="h-3 w-6" />
          </div>
        ))}
      </div>
      <div className="flex flex-1 flex-col">
        {Array.from({ length: 5 }).map((_, weekIdx) => {
          const isLastWeek = weekIdx === 4;
          return (
            <div key={weekIdx} className="flex flex-1">
              {DAY_NAMES.map((_, dayIdx) => {
                const hasEvent = (weekIdx * 7 + dayIdx) % 3 === 0;
                return (
                  <div
                    key={dayIdx}
                    className={cn(
                      "min-h-[78px] min-w-0 flex-1 border-r border-border p-1.5 last:border-r-0",
                      !isLastWeek && "border-b"
                    )}
                  >
                    <Skeleton className="mb-1 size-[19px] rounded-full" />
                    {hasEvent && <Skeleton className="h-[14px] w-full rounded" />}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
